import { DeferredPage } from "@/components/data-display/deferred-page";

// Deferred (ALL-5710). This route rendered authored fixtures from data/mock.ts and
// called no API: every service, deployment, user and setting on it was invented, and
// its actions only raised "Local preview only" toasts. It says so plainly until a
// real backend route exists (context/page_pipeline/BOARD.md).
export default function Page() {
  return (
    <DeferredPage
      nav={{ kind: "breadcrumb", parents: [{ label: "Deployment", href: "/admin/deployment" }], label: "Deployment detail" }}
      state={{
        title: "Deployment detail is not available in this environment yet",
        description: "Deployment status, acceptance checks and history are not read from a live release service yet. Nothing on this page reflects a real deployment.",
      }}
    />
  );
}
